import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { dispatchProps } from "../cnr/reducers/reducerHelpers/dispatchProps";
import { callFunction } from "./fbAll";
import { createRefPath, createRefPath_event } from "global/firestoreData/appData/appRefPaths";

export const createModes = {
  create: 'create',
  update: 'update'
}

const deleteGenericTypes = {
  deleteGeneric: 'deleteGeneric',
}

export const deleteFunctionTypes = {
  deleteClient: 'deleteClient',
  deleteClientCollection: 'deleteClientCollection',
  deleteEvent: 'deleteEvent',
  deleteEventCollection: 'deleteEventCollection',
  deleteEventCollections: 'deleteEventCollections',
  deleteFullClient: 'deleteFullClient',
  deleteFullEvent: 'deleteFullEvent',
  deleteTheFullEvent: 'deleteTheFullEvent',
  deleteEventStorage: 'deleteEventStorage',
}

/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success, result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(deleteGenericTypes.deleteGeneric, callData)
  return data
}

export const fsfn_delete = (fsCall) => ({
  deleteFullEventFromDatabase: (pathViews, viewItemKeys, storageRootPath, leaveEvent) => fsfn_deleteFullEventFromDatabase(fsCall, pathViews, viewItemKeys, storageRootPath, leaveEvent),
  deleteTheFullEventFromDatabase: (pathViews, viewItemKeys, storageRootPath, leaveEvent) => fsfn_deleteTheFullEventFromDatabase(fsCall, pathViews, viewItemKeys, storageRootPath, leaveEvent),
  deleteFullClientFromDatabase: (pathViews, storageRootPath) => fsfn_deleteFullClientFromDatabase(fsCall, pathViews, storageRootPath),
  deleteClientCollection: (pathViews, collectionName, batchSize, logging) => fsfn_deleteClientCollection(fsCall, pathViews, collectionName, batchSize, logging),
  deleteEventCollections: (pathViews, dataCollectionKeys, callbackWhenDone) => fsfn_deleteEventCollections(fsCall, pathViews, dataCollectionKeys, callbackWhenDone),
  deleteEventCollection: (pathViews, collectionName, batchSize) => fsfn_deleteEventCollection(fsCall, pathViews, collectionName, batchSize),
})

/**
 * 
 * @param {object} pathViews 
 * @param {array} viewItemKeys 
 * @param {string} storageRootPath 
 * @description Deletes the eventDocument after deleting all of the sub collections
 * @returns - response_data {success, result, error}
 */
const fsfn_deleteFullEventFromDatabase = async (fsCall, pathViews, viewItemKeys, storageRootPath, leaveEvent) => {
  try {
    const callData = { deleteFunctionType: deleteFunctionTypes.deleteFullEvent, pathViews, viewItemKeys, storageRootPath, leaveEvent, showLogs: true }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} pathViews 
 * @param {array} viewItemKeys 
 * @param {string} storageRootPath 
 * @description Deletes the eventDocument after deleting all of the sub collections
 * @returns - response_data {success, result, error}
 */
const fsfn_deleteTheFullEventFromDatabase = async (fsCall, pathViews, viewItemKeys, storageRootPath, leaveEvent) => {
  try {
    const callData = {
      deleteFunctionType: deleteFunctionTypes.deleteTheFullEvent,
      pathViews,
      viewItemKeys,
      storageRootPath,
      leaveEvent,
      showLogs: true,
      demoMode: false
    }
    const response_data = await callFsFunction(fsCall, callData) // OK  
    return response_data
  } catch (error) {
    console.error(error)
  }
}


/**
 * 
 * @param {object} pathViews 
 * @param {array} viewItemKeys 
 * @param {string} storageRootPath 
 * @description Deletes the eventDocument after deleting all of the sub collections
 * @returns - response_data {success, result, error}
 */
const fsfn_deleteFullClientFromDatabase = async (fsCall, pathViews, storageRootPath) => {
  try {
    const callData = { deleteFunctionType: deleteFunctionTypes.deleteFullClient, pathViews, storageRootPath }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {object} pathViews 
 * @param {string} collectionName 
 * @param {number} batchSize 
 * @param {object} logging 
 * @returns - response_data {success, result, error}
 */
const fsfn_deleteClientCollection = async (fsCall, pathViews, collectionName, batchSize, logging) => {
  const callData = { deleteFunctionType: deleteFunctionTypes.deleteClientCollection, pathViews, collectionName, batchSize, showLogs: logging && logging.allowLogging && logging.logDeleteCollection }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const fsfn_deleteClientCollections = async (fsCall, clientCollections, handleUpdating, dispatch, mainFunctions) => {
  try {
    clientCollections.forEach(async (key, index) => {
      handleUpdating && handleUpdating(key)
      // fsfn_deleteClientCollection(pathViews, key, 100, mainFunctions).then(response_data => {
      //   const { success, error } = response_data ?? {}
      //   dispatch && dispatch({ type: success ? dispatchProps.success : dispatchProps.error, error })
      // }).catch(error => {
      //   dispatch && dispatch({ type: dispatchProps.error, error })
      // })
      // }
    })
  } catch (err) {
    dispatch && dispatch({ type: dispatchProps.error, error: err })
  }
}

const fsfn_deleteEventCollections = (fsCall, pathViews, dataCollectionKeys, callbackWhenDone) => {
  const items = {}
  dataCollectionKeys.forEach(async (dcKey, index) => {
    // delete a single collection (await)
    const response_data = await fsfn_deleteEventCollection(fsCall, pathViews, dcKey, 100)
    const { success, error } = response_data ?? {}
    items[dcKey] = { icon: 'check', color: success ? 'green' : 'red', success: success, error }
    if (Object.keys(items).length === dataCollectionKeys.length) { callbackWhenDone(items) }
  })
}

/**
 * 
 * @param {string} pathViews The database path
 * @param {string} collectionName Name of the collection to be deleted
 * @param {number} batchSize Size of the delete batch. Must be <= 100
 * @param {object} logging Contains information about whether logging will triggered in functions
 * @description Deletes all the items from a single collection under the `event` document
 * @returns response_data {success, result, error}
 */
const fsfn_deleteEventCollection = async (fsCall, pathViews, collectionName, batchSize) => {
  const callData = { deleteFunctionType: deleteFunctionTypes.deleteEventCollection, pathViews, collectionName, batchSize, showLogs: true } // logging && logging.allowLogging && logging.logDeleteCollection }
  try {
    const response_data = await callFsFunction(fsCall, callData)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

// export const fsfn_deleteEventCollections = async (pathViews, dataCollectionKeys, batchSize, logging) => {
//   const callData = { deleteFunctionType: deleteFunctionTypes.deleteEventCollections, pathViews, dataCollectionKeys, batchSize, showLogs: logging && logging.allowLogging && logging.logDeleteCollection }
//   try {
//     const response_data = await callFsFunction(callData)
//     console.log('response_data', response_data);
//     return response_data
//   } catch (error) {
//     console.error(error)
//     return { type: dispatchProps.error, error }
//   }
// }

// export const fsfn_deleteTheFullEventStorage = async (pathViews, viewItemKeys, storageRootPath, leaveEvent, mainFunctions) => {
//   try {
//     const callData = {
//       deleteFunctionType: deleteFunctionTypes.deleteEventStorage,
//       pathViews,
//       viewItemKeys,
//       storageRootPath,
//       leaveEvent,
//       showLogs: true,
//       demoMode: true
//     }
//     const response_data = await callFsFunction(callData, mainFunctions) // OK  
//     return response_data
//     return {}
//   } catch (error) {
//     console.error(error)
//   }
// }

export const deleteAllDocsInCollection = async (mainDb, pathViews, collectionName) => {
  try {
    const refPath = createRefPath_event(pathViews, [collectionName])
    const colRef = collection(mainDb, refPath);
    const snapshot = await getDocs(colRef);

    if (snapshot.empty) {
      console.log('No documents to delete.');
      return;
    }

    const deletePromises = snapshot.docs.map((document) => deleteDoc(doc(mainDb, collectionName, document.id)));
    await Promise.all(deletePromises);

    console.log(`Deleted ${snapshot.size} documents from "${collectionName}"`);
  } catch (error) {
    console.error('Error deleting documents:', error);
  }
};

export const deleteAllDocsInCollections = async (mainDb, pathViews, collectionNames = []) => {
  try {
    const results = await Promise.all(
      collectionNames.map((collectionName) => deleteAllDocsInCollection(mainDb, pathViews, collectionName))
    );

    const totalDeleted = results.reduce((sum, count) => sum + count, 0);
    console.log(`Deleted ${totalDeleted} documents across ${collectionNames.length} collections`);
  } catch (error) {
    console.error('Error deleting collections:', error);
  }
};